import { Injectable } from '@angular/core';

import { IAsyncTaskReport, ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class QuoteBulkTransitionReport implements IAsyncTaskReport {

  public generate(task: ITask): string {
    if (task.status === 'success') {
      return `<div>Transition des devis validée..<br>`;
    } else {
      return '<div>Erreur lors de la transition des devis, veuillez vérifier la configuration des devis puis réessayer à nouveau.</div>';
    }
  }
}
